import request from './request';

const authService = {
  login: (data) => request.post('/auth/dashboard/login', data),
  logout: (data) => request.post('auth/logout', data),
  verifyDashboardOtp: ({ temp_token, otp }) =>
    request.post('auth/dashboard/verify-otp?'+temp_token+'&otp='+otp,{temp_token, otp}),
  requestPasswordReset: (email) =>
    request.post('auth/forgot/email-password', { email }),
  verifyOtp: (email, otp) =>
    request.post(`auth/forgot/email-password/${otp}/`, {
      email,
      otp,
    }),
  resetPassword: (data) => {
    const params = new URLSearchParams({
      password: data.password,
      password_confirmation: data.password_confirmation,
    });
    return request.post(`dashboard/user/profile/password/reset?${params.toString()}`);
  },
  // Send Cloudflare Turnstile token to backend for verification
  verifyTurnstile: (token) => request.post('auth/turnstile/verify', { token }),
};

export default authService;
